module.exports = __webpack_public_path__ + "img/200616_DANV-Highlightblatt-SBU_Mockup.7eaa91cd.jpg";